import React from "react";
import { Form, Modal } from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";
import Table from "react-bootstrap/Table";
import { useState, useEffect, useRef } from "react";
import axios from ".././axios-interceptor";
import moment from "moment/moment";
import Swal from 'sweetalert2';
import {decrypt} from '../utils';
import { sortLoanHistory, loanEventMessage,
  base_url,
  STATUS_NEW,
  STATUS_IN_PROGRESS,
  STATUS_APPROVED,
  STATUS_REJECTED,
  STATUS_PROCESSED,
  LOAN_CURRENCY_TYPE_BHD,
  LOAN_CURRENCY_TYPE_USD,
  SERVICE_REQUEST_NEW_LOAN,
  SERVICE_REQUEST_EXTEND_TENURE,
  SERVICE_REQUEST_PRE_CLOSURE,
  SERVICE_REQUEST_PARTIAL_PRE_PAYMENT,
  LOAN_REPAYMENT_BY_BUSINESS,
  STATUS_CLOSED,
  AUDITOR_ROLE,
  SUBSCRIPTION_STATUS_ACTIVE,
  OPPORTUNITY_STATUS_OPEN,
  OPPORTUNITY_STATUS_FULLY_FUNDED,
  OPPORTUNITY_STATUS_DISBURSING,
} from "./../utilities";
import InvestorBreakdownTab from "./InvestorBreakdownTab";
import Cookies from 'js-cookie';
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";

const NewInvDetailedView = (props) => {
  const loanID = props.data?.loan_id;
  const [activeTab, setActiveTab] = useState("paymentScheduledetails-tab");
  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });
  const [file, setUploadFile] = useState(null); //setUploadedUrl
  const [isUpload, setIsUpload] = useState(false);
  const [url, setUploadedUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [penaltyBreakdown, setPenaltyBreakdown] = useState(null)
  const [penaltyLoading, setPenaltyLoading] = useState(false)
  const [showWaiverModal, setShowWaiverModal] = useState(false)
  const [waiverSchedule, setWaiverSchedule] = useState(null)
  const [waiverType, setWaiverType] = useState('none')
  const [waiverAmount, setWaiverAmount] = useState(0)
  const [waiverReason, setWaiverReason] = useState('')
  const [waiverPreview, setWaiverPreview] = useState(null)
  const [waiverConfirmed, setWaiverConfirmed] = useState(false)
  const [waiverLoading, setWaiverLoading] = useState(false)
  const [waiverPreviewLoading, setWaiverPreviewLoading] = useState(false)
  const [charges, setCharges] = useState([])
  const [chargesLoading, setChargesLoading] = useState(false)
  const [showChargeModal, setShowChargeModal] = useState(false)
  const [chargeType, setChargeType] = useState('')
  const [chargeAmount, setChargeAmount] = useState('')
  const [investorAllocation, setInvestorAllocation] = useState('')
  const [chargeDescription, setChargeDescription] = useState('')
  const [chargeRemarks, setChargeRemarks] = useState('')
  const [chargeDate, setChargeDate] = useState('')
  const [chargeLoading, setChargeLoading] = useState(false)
  const [chargeTypes, setChargeTypes] = useState([])
  const [closureEligibility, setClosureEligibility] = useState(null)
  const [closureEligibilityLoading, setClosureEligibilityLoading] = useState(false)
  const [showCloseLoanModal, setShowCloseLoanModal] = useState(false)
  const [closeLoanConfirmed, setCloseLoanConfirmed] = useState(false)
  const [closeLoanLoading, setCloseLoanLoading] = useState(false)
  const [recordPaymentChargeId, setRecordPaymentChargeId] = useState(null)
  const [recordPaymentAmount, setRecordPaymentAmount] = useState('')
  const [recordPaymentLoading, setRecordPaymentLoading] = useState(false)
  // Multi-investor (Fund Now) loans: subscriptions from loan-investor-subscriptions/get_by_loan.
  // The loan payload has no usable investor_request_id for these, so it comes from subs[0].
  const [subscriptions, setSubscriptions] = useState([])
  // 'loading' | 'loaded' | 'failed' for get_by_loan; repayments stay locked until it has loaded.
  const [subscriptionsState, setSubscriptionsState] = useState('loading')
  // Opportunity status of a multi-investor loan (get_breakdown here, refreshed by the Investor Breakdown tab).
  const [opportunityStatus, setOpportunityStatus] = useState(null)
  const [opportunityStatusFailed, setOpportunityStatusFailed] = useState(false)
  // Investor names from get_breakdown, so a Fund Now loan with one investor shows that investor's name.
  const [breakdownInvestors, setBreakdownInvestors] = useState([])

  const handleClose = () => {
    props.onHide();
    setUploadFile(null);
    setUploadedUrl(null);
    setIsUpload(false);
    setFilterDate("");
    setSelectedType("")
    setPaidDate("")
    setPenaltyBreakdown(null)
    setEnteredpenaltyAmount(null)
    setEnteredAmount(null)
    setComments("")
    setActiveTab("paymentScheduledetails-tab");
    singleInvTableData?.map((element) => {
      element.is_selected = false;
    });
  };
  const fetchCharges = (loan_id) => {
    setChargesLoading(true)
    axios.post(base_url + 'loan-charges/get_charges_by_loan', { loan_id })
      .then(res => {
        if (res.data.status === 200) setCharges(res.data.data)
      })
      .catch(err => console.log(err))
      .finally(() => setChargesLoading(false))
  }

  const handleCreateCharge = () => {
    if (!chargeType || !chargeAmount || !chargeDate) {
      toast.error('Charge type, amount and date are required', { toastId: 201 })
      return
    }
    if (!chargeDescription.trim()) {
      toast.error('Description is mandatory', { toastId: 207 })
      return
    }
    if (Number(chargeAmount) <= 0) {
      toast.error('Charge amount must be greater than 0', { toastId: 209 })
      return
    }
    if (Number(investorAllocation) < 0) {
      toast.error('Investor allocation cannot be negative', { toastId: 210 })
      return
    }
    const today = new Date().toISOString().split('T')[0]
    if (chargeDate > today) {
      toast.error('Charge date cannot be in the future', { toastId: 208 })
      return
    }
    if (Number(investorAllocation) > 100) {
      toast.error('Investor allocation percentage cannot exceed 100%', { toastId: 202 })
      return
    }
    setChargeLoading(true)
    const investorAmount = Math.round((Number(investorAllocation) / 100) * Number(chargeAmount) * 100) / 100
    axios.post(base_url + 'loan-charges/create_charge', {
      loan_id: loanID,
      charge_type: chargeType,
      charge_amount: Number(chargeAmount),
      investor_allocation: investorAmount,
      description: chargeDescription,
      remarks: chargeRemarks,
      charge_date: Date.parse(chargeDate),
      created_by: Cookies.get('admin_user_name'),
      created_by_user_id: Cookies.get('admin_user_id')
    })
    .then(res => {
      if (res.data.status === 200) {
        toast.success('Charge created successfully', { toastId: 200 })
        setShowChargeModal(false)
        setChargeType('')
        setChargeAmount('')
        setInvestorAllocation('')
        setChargeDescription('')
        setChargeRemarks('')
        setChargeDate('')
        fetchCharges(loanID)
      } else {
        toast.error(res.data.message, { toastId: 203 })
      }
    })
    .catch(err => {
      toast.error('Failed to create charge', { toastId: 204 })
      console.log(err)
    })
    .finally(() => setChargeLoading(false))
  }

  const handleCheckCharge = (loan_charge_id) => {
    axios.post(base_url + 'loan-charges/check_charge', {
      loan_charge_id,
      checked_by: Cookies.get('admin_user_name'),
      checked_by_user_id: Cookies.get('admin_user_id')
    })
    .then(res => {
      if (res.data.status === 200) {
        toast.success('Charge verified successfully', { toastId: 205 })
        fetchCharges(loanID)
      } else {
        toast.error(res.data.message, { toastId: 206 })
      }
    })
    .catch(err => console.log(err))
  }

  const handleRecordChargePayment = (loan_charge_id) => {
    if (!recordPaymentAmount || Number(recordPaymentAmount) <= 0) {
      toast.error('Enter a valid payment amount', { toastId: 220 })
      return
    }
    setRecordPaymentLoading(true)
    axios.post(base_url + 'loan-charges/record_payment', {
      loan_charge_id,
      amount_paid: Number(recordPaymentAmount),
      admin_user_name: Cookies.get('admin_user_name'),
      admin_user_id: Cookies.get('admin_user_id')
    })
    .then(res => {
      if (res.data.status === 200) {
        toast.success('Charge payment recorded', { toastId: 221 })
        setRecordPaymentChargeId(null)
        setRecordPaymentAmount('')
        fetchCharges(loanID)
        fetchClosureEligibility(loanID)
      } else {
        toast.error(res.data.message, { toastId: 222 })
      }
    })
    .catch(err => console.log(err))
    .finally(() => setRecordPaymentLoading(false))
  }

  // This modal stays mounted while the admin switches loans, so a late reply for the previous loan
  // must be dropped rather than applied to the one now open.
  const currentLoanRef = useRef(loanID)
  currentLoanRef.current = loanID
  const isStale = (loan_id) => String(currentLoanRef.current) !== String(loan_id)

  const fetchSubscriptions = (loan_id, { keepCurrent = false } = {}) => {
    // keepCurrent: a refresh must not blank the list, or the Investor Breakdown tab would unmount.
    if (!keepCurrent) {
      setSubscriptions([])
      setSubscriptionsState('loading')
      setOpportunityStatus(null)
      setOpportunityStatusFailed(false)
      setBreakdownInvestors([])
    }
    axios.post(base_url + 'loan-investor-subscriptions/get_by_loan', { loan_id })
      .then(res => {
        if (isStale(loan_id)) return
        if (res?.data?.status === 200 && Array.isArray(res.data.data)) {
          setSubscriptions(res.data.data)
          setSubscriptionsState('loaded')
          const irId = res.data.data[0]?.investor_request_id
          if (irId) fetchOpportunityStatus(irId, loan_id)
        } else if (!keepCurrent) {
          setSubscriptionsState('failed')
        }
      })
      .catch(err => {
        console.log(err)
        if (!keepCurrent && !isStale(loan_id)) setSubscriptionsState('failed')
      })
  }

  // The opportunity's status decides whether repayments may be recorded (only after disbursement).
  const fetchOpportunityStatus = (investor_request_id, loan_id = loanID) => {
    axios.post(base_url + 'loan-investor-subscriptions/get_breakdown', { investor_request_id })
      .then(res => {
        if (isStale(loan_id)) return
        if (res?.data?.status === 200 && res.data.data) {
          setOpportunityStatus(res.data.data.status ?? null)
          setBreakdownInvestors(Array.isArray(res.data.data.investors) ? res.data.data.investors : [])
          setOpportunityStatusFailed(false)
        } else {
          setOpportunityStatusFailed(true)
        }
      })
      .catch(err => {
        console.log(err)
        if (!isStale(loan_id)) setOpportunityStatusFailed(true)
      })
  }

  // Reopening the modal retries a failed status check (the load effect only re-runs on loan change),
  // so a one-off network failure doesn't leave Record Payment locked until a page reload.
  useEffect(() => {
    if (props.show && loanID && (subscriptionsState === 'failed' || opportunityStatusFailed)) {
      fetchSubscriptions(loanID)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show])

  // Refetch the loan payload after a breakdown change / reconcile (amounts, status may move).
  const refreshLoanDetails = () => {
    if (!loanID) return
    axios.post(base_url + 'investor-interests/get_single_investment_interest', { loan_id: loanID })
      .then(r => {
        if (r?.data?.status === 200 && r.data.data) {
          let data = r.data.data
          data.payment_schedule?.map((ele) => {
            ele.is_selected = false
            ele.color = 'black'
          })
          setSingleInvTableData(data.payment_schedule)
          setSingleInvDataforCancel(data.payment_schedule)
          setSingleInvIntDetails(data)
        }
      })
      .catch(err => console.log(err))
    fetchSubscriptions(loanID, { keepCurrent: true })
  }

  const fetchClosureEligibility = (loan_id) => {
    setClosureEligibilityLoading(true)
    axios.post(base_url + 'loan-trx/get_closure_eligibility', { loan_id })
      .then(res => {
        if (res.data.status === 200) setClosureEligibility(res.data.data)
      })
      .catch(err => console.log(err))
      .finally(() => setClosureEligibilityLoading(false))
  }

  const handleOpenCloseLoanModal = () => {
    setCloseLoanConfirmed(false)
    setShowCloseLoanModal(true)
  }

  const handleCloseLoan = () => {
    if (!closeLoanConfirmed) {
      toast.error('Please confirm the closure by ticking the checkbox', { toastId: 223 })
      return
    }
    if (!closureEligibility?.isSettled) {
      toast.error('Loan cannot be closed while amounts remain outstanding', { toastId: 224 })
      return
    }
    setCloseLoanLoading(true)
    axios.post(base_url + 'loan-trx/close_loan', {
      loan_id: loanID,
      admin_user_name: Cookies.get('admin_user_name'),
      admin_user_id: Cookies.get('admin_user_id')
    })
    .then(res => {
      if (res.data.status === 200) {
        toast.success('Loan closed successfully', { toastId: 225 })
        setShowCloseLoanModal(false)

        // Refresh loan details so status/closed_by/closed_date_time reflect the closure
        axios.post(base_url + 'investor-interests/get_single_investment_interest', {
          loan_id: loanID
        }).then(r => {
          if (r.data.status === 200) {
            let data = r.data.data
            data.payment_schedule?.map((ele) => {
              ele.is_selected = false
              ele.color = 'black'
            })
            setSingleInvTableData(data.payment_schedule)
            setSingleInvIntDetails(data)
          }
        })
      } else {
        toast.error(res.data.message, { toastId: 226 })
      }
    })
    .catch(err => console.log(err))
    .finally(() => setCloseLoanLoading(false))
  }

  const [singleinvintDetails, setSingleInvIntDetails] = useState([]);
  const [singleInvTableData, setSingleInvTableData] = useState([]);
  const [singleInvDataforCancel, setSingleInvDataforCancel] = useState([]);
  const [getTenureDates, setGetTenureDates] = useState([]);
  const [filterDate, setFilterDate] = useState([]);
  const [dataloading, setDataloading] = useState(false);
  const [defaultSelect, setDefaultSelect] = useState(false);


  let documents = singleinvintDetails.documents;
  useEffect(() => {
    let loanID = props.data.loan_id;
    if (loanID) {
      setDataloading(true)
      axios
        .post(base_url + "investor-interests/get_single_investment_interest", {
          loan_id: loanID,
        })
        .then((res) => {
       
          let data = res.data.data;
          data.payment_schedule?.map((ele) => {
            ele.is_selected = false;
            ele.color = "black";
          });
          if (!data) {
            <ThreeDots
              height="30"
              width="30"
              radius="9"
              color="#4fa94d"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />;
          } else {
            setSingleInvTableData(data.payment_schedule);
            setSingleInvDataforCancel(data.payment_schedule);
            setSingleInvIntDetails(data);
            setDataloading(false)

          }
        });

      axios
        .post(base_url + "payment-schedules/get_tenure_dates", {
          loan_id: loanID,
        })
        .then((res) => {
          let data = res.data.data;
          setGetTenureDates(data);
        });
        fetchCharges(loanID)
        fetchClosureEligibility(loanID)
        fetchSubscriptions(loanID)
        axios.get(base_url + 'loan-charges/get_charge_types')
        .then(res => { if (res.data.status === 200) setChargeTypes(res.data.data) })
        .catch(err => console.log(err))
    }
  }, [loanID]);

   const [roleCode, setRoleeCode] = useState(() => {
      const storedRoleeCode = Cookies.get('role_code');
      return storedRoleeCode ? storedRoleeCode : '';
    });
  
    useEffect(()=>{
      if (roleCode) {
        try {
          const decryptedValueData = decrypt(roleCode);
          setRoleeCode(decryptedValueData);
        } catch (error) {
          console.error('Decryption error:', error);
        }
      }
    },[])

  const [selectedtype, setSelectedType] = useState();
  const [enteredAmount, setEnteredAmount] = useState(null);
  const [enteredpenaltyamount, setEnteredpenaltyAmount] = useState(null);
  const [paidDate, setPaidDate] = useState();
  const [comments, setComments] = useState();

  const columns = [
    {
      title: "Profit Rate Payment",
      field: "tenure_amount",
      currency: "admin_request_loan_currency",
    },
    { title: "Tenure Date", field: "tenure_date" },
    {
      title: "Amount Repaid",
      field: "paid_amount",
      currency: "admin_request_loan_currency",
    },
    {
      title: "Penalty",
      field: "penalty_amount",
      currency: "admin_request_loan_currency",
    },
    {
      title: "Actions",
    },
  ];
  const received_via_names = [
    "Wire Transfer",
    "Paid from Bank Account",
    "Cash",
    "Cheque",
    "Others",
  ];
  const radioButtonMethodRating = (e) => {
    setSelectedType(e);
  };
const [inputValue, setInputValue] = useState()
const[fetchedUserId,setFetchedUserId]=useState();
  const handleChangeInput = (e) => {
    const { target } = e;
    const value = target.value;
    const name = target.name;
    const dueAmount = Number(filterDate?.due_amount);
    const inputAmount = Number(value);

    if (name === "paidamount" && inputAmount > dueAmount) {
      toast.error("Paid amount should be less than or equal to due amount", {
        toastId: 3,
      });
      setEnteredAmount("");
      target.value = null;
    } else if (name === "paidamount") {
      if (value === "") {
        setEnteredAmount(null);
      } else {
        setEnteredAmount(parseFloat(inputAmount));
      }
    }

    if (name === "penaltyamount") {
      if (value === "" || value === 0) {
        setEnteredpenaltyAmount(null);
      } else {
        setEnteredpenaltyAmount(parseFloat(inputAmount));
      }
    }
    if (name === "tenuredate") {
      setEnteredAmount("");
      document.getElementsByName("paidamount")[0].value = "";
      let f = getTenureDates.filter((item) => {
        let formatDate = moment(item.tenure_date).format("DD MMM YYYY");
        if (value === formatDate) {
          return item;
        }
      });
      if (value === "Select") {
        setFilterDate("");
      } else {
        setFilterDate(f[0]);
      }
      setPenaltyBreakdown(null);
      setEnteredpenaltyAmount(null);
      setPaidDate("");
    }
    // if (name === "paiddate") {
    //   let datum = Date.parse(e.target.value);
    //   if (isNaN(datum)) {
    //     setPaidDate("");
    //     datum = "";
    //   } else {
    //     setPaidDate(datum);
    //   }
    // }
    if (name === "paiddate") {
      let datum = Date.parse(e.target.value);
      if (isNaN(datum)) {
        setPaidDate("");
        setPenaltyBreakdown(null);
        setEnteredpenaltyAmount(null);
      } else {
        setPaidDate(datum);
        // Only calculate if tenure date is also selected
        if (filterDate?.payment_schedule_id) {
          setPenaltyLoading(true);
          axios
            .post(base_url + "payment-schedules/calculate_penalty", {
              payment_schedule_id: filterDate.payment_schedule_id,
              paid_date: datum,
            })
            .then((res) => {
              if (res.data.status === 200) {
                setPenaltyBreakdown(res.data.data);
                setEnteredpenaltyAmount(res.data.data.penalty_amount);
              }
            })
            .catch((err) => console.log(err))
            .finally(() => setPenaltyLoading(false));
        }
      }
    }
  };

  const handleChangeInputComments = (e) => {
    setComments(e.target.value);
  };
  

  const handleCancelClick = (id) => {
    let schd = [...singleInvDataforCancel];
    schd.map((ele) => {
      if (ele.payment_schedule_id === id) {
        ele.is_selected = false;
        ele.color = "black";
      }
      setSingleInvTableData(schd);
      setPaidAmount(ele.paid_amount);
      setRepaidAmountvalue(ele.paid_amount);
      setPenaltyAmountValue(ele.penalty_amount);
    });
  };
  const [userId,setUserId]=useState(Cookies.get("admin_user_id"));

  const onPenClick = (id) => {
    let sch = [...singleInvTableData];
    sch.map((ele) => {
      if (ele.payment_schedule_id === id) {
        ele.is_selected = true;
        ele.color = "yellow";
        setPenaltyAmountValue(ele.penalty_amount);
      setRepaidAmountvalue(ele.paid_amount);

      } else {
        ele.is_selected = false;
        ele.color = "black";
      }
      setSingleInvTableData(sch);
    });
  };
  const onWaiverClick = (scheduleRow) => {
    setWaiverSchedule(scheduleRow)
    setWaiverType('none')
    setWaiverAmount(0)
    setWaiverReason('')
    setWaiverPreview(null)
    setWaiverConfirmed(false)
    setShowWaiverModal(true)
  }

  const fetchWaiverPreview = (type, amount) => {
    if (!waiverSchedule || type === 'none') {
      setWaiverPreview(null)
      return
    }
    setWaiverPreviewLoading(true)
    axios.post(base_url + 'waivers/get_waiver_preview', {
      payment_schedule_id: waiverSchedule.payment_schedule_id,
      waiver_type: type,
      waiver_amount: amount || 0,
      live_penalty_amount: waiverSchedule.penalty_amount || 0
    })
    .then(res => {
      if (res.data.status === 200) setWaiverPreview(res.data.data)
    })
    .catch(err => console.log(err))
    .finally(() => setWaiverPreviewLoading(false))
  }

  const handleWaiverTypeChange = (type) => {
    setWaiverType(type)
    setWaiverAmount(0)
    setWaiverConfirmed(false)
    fetchWaiverPreview(type, 0)
  }

  const handleWaiverAmountChange = (val) => {
    setWaiverAmount(val)
    setWaiverConfirmed(false)
    if (waiverType === 'Partial Waiver') {
      fetchWaiverPreview('Partial Waiver', val)
    }
  }

  const handleApplyWaiver = () => {
    if (!waiverConfirmed) {
      toast.error('Please confirm the waiver by ticking the checkbox', { toastId: 91 })
      return
    }
    if (!waiverReason.trim()) {
      toast.error('Waiver reason is mandatory', { toastId: 92 })
      return
    }
    if (waiverType === 'none') {
      toast.error('Please select a waiver type', { toastId: 93 })
      return
    }
    if (waiverPreview?.is_over_waiver) {
      toast.error('Waiver amount exceeds maximum waivable amount', { toastId: 94 })
      return
    }
    setWaiverLoading(true)
    axios.post(base_url + 'waivers/apply_waiver', {
      payment_schedule_id: waiverSchedule.payment_schedule_id,
      waiver_type: waiverType,
      waiver_amount: waiverAmount,
      waiver_reason: waiverReason.trim(),
      approved_by: Cookies.get('admin_user_name'),
      admin_user_id: Cookies.get('admin_user_id'),
      live_penalty_amount: waiverSchedule.penalty_amount || 0
    })
    .then(res => {
      if (res.data.status === 200) {
        toast.success('Waiver applied successfully', { toastId: 90 })
        setShowWaiverModal(false)

        // Refresh payment schedule table
        axios.post(base_url + 'investor-interests/get_single_investment_interest', {
          loan_id: loanID
        }).then(r => {
          if (r.data.status === 200) {
            let data = r.data.data
            data.payment_schedule?.map((ele) => {
              ele.is_selected = false
              ele.color = 'black'
            })
            setSingleInvTableData(data.payment_schedule)
            setSingleInvIntDetails(data)
          }
        })

        // Refresh tenure dates so filterDate.waived_amount is updated
        // This makes "Waiver already applied" badge show on Record Payment tab
        axios.post(base_url + 'payment-schedules/get_tenure_dates', {
          loan_id: loanID
        }).then(r => {
          if (r.data.status === 200) {
            let data = r.data.data
            setGetTenureDates(data)
            // Also update filterDate if it matches the waived schedule
            if (filterDate?.payment_schedule_id === waiverSchedule?.payment_schedule_id) {
              const updated = data.find(d => d.payment_schedule_id === waiverSchedule.payment_schedule_id)
              if (updated) setFilterDate(updated)
            }
          }
        })
      } else {
        toast.error(res.data.message, { toastId: 95 })
      }
    })
    .catch(err => {
      toast.error('Failed to apply waiver', { toastId: 96 })
      console.log(err)
    })
    .finally(() => setWaiverLoading(false))
  }
  const [editAmount, setEditAmount] = useState(null);
  const [paidAmount, setPaidAmount] = useState(null);
  const [penaltyAmountValue, setPenaltyAmountValue] = useState();

  const handlePenaltyAmt = (e, id, amount) => {
    let schdPdamt = [...singleInvTableData];
    let value = e.target.value;
    schdPdamt.map((ele) => {
      if (ele.payment_schedule_id === id) {
        if (value !== "" || value !== undefined) {
          setPenaltyAmountValue(value);
        } 
      }
    });
  };
  const [repaidAmountvalue, setRepaidAmountvalue] = useState();
  const handleEditAmtPaid = (e, id) => {
    let schdPdamt = [...singleInvTableData];
    const { target } = e;
    const name = target.name;
    const value = target.value;
    const inputAmount = Number(value).toFixed(2);
    schdPdamt.map((ele) => {
      if (ele.payment_schedule_id === id) {
        if (value !== undefined || value !== "") {
          if(name === "paidAmt" && inputAmount > Number(ele.tenure_amount)){
            toast.error("Repaid amount should be less than or equal to tenure amount", {
              toastId: 123,
            });
            target.value = null;
          }else{

            setRepaidAmountvalue(Number(value));
          }
        }
        setSingleInvTableData(schdPdamt);
      }
    });
  };
  let paidAmount_array = [];

  const handleRightClick = (id) => {
   

    axios
      .post(
        base_url +
        "payment-schedules/update_payment_amount_by_payment_schedule_id",
        {
          payment_schedule_id: id,
          paid_amount: repaidAmountvalue == undefined || repaidAmountvalue == ""
            ? paidAmount_array[0]?.paid_amount
            : Number(repaidAmountvalue),
          created_by: Cookies.get('admin_user_name'),
          admin_user_id: Cookies.get('admin_user_id') ,
          penalty_amount: Number(penaltyAmountValue),
        }
      )
      .then((res) => {
        
        
        if (res.data.message === "maker cannot be checker for the transaction") {

          Swal.fire({
            title: 'Alert',
            text: 'Maker cannot be Checker for the transaction.',
            icon: 'warning',
            confirmButtonText: 'Okay',
            allowOutsideClick: false,  
          })
           
          // toast.error("Maker cannot be Checker for the transaction", {
          //   toastId: 414,
          // });

          let updatedata = [...singleInvTableData];

          updatedata.map((ele) => {
            if (ele.payment_schedule_id === id) {
              ele.color = "black";
              ele.is_selected = false;
            
            }
          })
          setSingleInvTableData(updatedata)

        }

        else {
          // Fund Now: verifying a fully repaid tenure pays the investors automatically.
          if (res.data?.payout?.paid) {
            toast.success(`Verified and paid out to ${res.data.payout.investors} investor${res.data.payout.investors === 1 ? '' : 's'}`, { toastId: 418 });
          } else if (res.data?.payout && !res.data.payout.paid) {
            toast.warn(res.data.message, { toastId: 419 });
          }
          let schd = [...singleInvTableData];

          schd.map((ele) => {
            if (ele.payment_schedule_id === id) {
              ele.is_selected = false;
              if (ele.tenure_amount === ele.paid_amount) { ele.color = "green" }
              paidAmount_array.push(ele);
      
              if (repaidAmountvalue != undefined) {
                ele.paid_amount = Number(repaidAmountvalue);
              }
      
              if (penaltyAmountValue !== "" || penaltyAmountValue !== undefined) {
                ele.penalty_amount = Number(penaltyAmountValue);
              } else {
                ele.penalty_amount = Number(ele.penalty_amount);
              }
            }
          });
          axios
            .post(base_url + "investor-interests/get_single_investment_interest", {
              loan_id: loanID,
            })
          .then((res) => {

            let data = res.data.data;
            data.payment_schedule?.map((ele) => {
              ele.is_selected = false;
              ele.color = "black";
            });
            if (!data) {
              <ThreeDots
                height="30"
                width="30"
                radius="9"
                color="#4fa94d"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />;
            } else {
              setSingleInvTableData(data.payment_schedule);
              setSingleInvDataforCancel(data.payment_schedule);
              setSingleInvIntDetails(data);


            }
          });

          axios
            .post(base_url + "payment-schedules/get_tenure_dates", {
              loan_id: loanID,
            })
            .then((res) => {
              let data = res.data.data;
              setGetTenureDates(data);
            });
          setUploadFile(null);
          setUploadedUrl(null);
          setIsUpload(false);
          setFilterDate("");
          setActiveTab("paymentScheduledetails-tab");
          singleInvTableData?.map((element) => {
            element.is_selected = false;
          });
          setDefaultSelect(true)
          setSelectedType("")
          setComments("")
          setPaidDate("")
          setEnteredAmount("")
          setLoading(false);


          toast.success("Successfully verified", {
            toastId: 413,
          });

          setSingleInvTableData(schd)
        }
      });
  };
 

  const submitted = () => {
    if (recordPaymentLocked) {
      toast.error(recordPaymentLockReason || "Record payment is locked for this loan", { toastId: 107 });
      return;
    }
    const fd1 = new FormData();
    fd1.append("payment_schedule_id", filterDate?.payment_schedule_id);
    fd1.append("tenure_date", filterDate?.tenure_date);
    fd1.append("tenure_amount", filterDate?.tenure_amount);
    fd1.append("paid_date", paidDate);
    fd1.append("paid_amount", enteredAmount);
    // fd1.append(
    //   "penalty_amount",
    //   enteredpenaltyamount == null ? 0 : enteredpenaltyamount
    // );
    fd1.append(
      "penalty_amount",
      enteredpenaltyamount == null ? 0 : enteredpenaltyamount
    );
    fd1.append("paid_currency", filterDate?.admin_request_loan_currency);
    fd1.append("received_via", selectedtype);
    fd1.append("document_url", url === "" ? null : url);
    fd1.append("comments", comments);
    fd1.append("created_by", Cookies.get("admin_user_name"));
    fd1.append("admin_user_id", Cookies.get("admin_user_id"));
    if (url != null) {
      const fileName = file;
      const lastDotIndex = fileName.lastIndexOf(".");
      const fileExtension = fileName.substring(lastDotIndex + 1);
      fd1.append("file", url, fileExtension);
    }
    if (
      enteredAmount === undefined ||
      enteredAmount === "" ||
      enteredAmount === null ||
      paidDate === undefined ||
      paidDate === "" ||
      paidDate === null ||
      selectedtype === undefined ||
      selectedtype === "" ||
      filterDate?.tenure_date === "" ||
      filterDate?.tenure_date === undefined ||
      filterDate?.tenure_date === "Select"
    ) {
      toast.error("Please fill out mandatory fields", {
        toastId: 3,
      });
    }
    if (enteredAmount === 0) {
      toast.error("Please check paid amount", {
        toastId: 106,
      });
      setEnteredAmount("");
    } else {
      setLoading(true);

      axios
        .post(base_url + "payment-schedules/update_tenure_payment", fd1, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res.data.status == 200) {
            setActiveTab("paymentScheduledetails-tab");
            // props.onHide();
            toast.success("Successfully saved", {
              toastId: 20,
            });

            
              setDataloading(true)
              axios
                .post(base_url + "investor-interests/get_single_investment_interest", {
                  loan_id: loanID,
                })
                .then((res) => {
                  let data = res.data.data;
                  data.payment_schedule?.map((ele) => {
                    ele.is_selected = false;
                    ele.color = "black";
                  });
                  if (!data) {
                    <ThreeDots
                      height="30"
                      width="30"
                      radius="9"
                      color="#4fa94d"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClassName=""
                      visible={true}
                    />;
                  } else {
                    setSingleInvTableData(data.payment_schedule);
                    setSingleInvDataforCancel(data.payment_schedule);
                    setSingleInvIntDetails(data);
                     
        
                  }
                });
        
              axios
                .post(base_url + "payment-schedules/get_tenure_dates", {
                  loan_id: loanID,
                })
                .then((res) => {
                  let data = res.data.data;
                  setGetTenureDates(data);
                });
                setUploadFile(null);
                setUploadedUrl(null);
                setIsUpload(false);
                setFilterDate("");
                setActiveTab("paymentScheduledetails-tab");
                singleInvTableData?.map((element) => {
                  element.is_selected = false;
                });
                setDefaultSelect(true)
                setSelectedType("")
                setComments("")
                setPaidDate("")
                setEnteredAmount("")
            setLoading(false);
            

            // setTimeout(() => {
            //   window.location.reload();
            // }, 800);
          }
        });
    }
  };

  const handleChange = (event) => {
    if (event.target.files[0].size < 5242880) {
      setIsUpload(true);
      setUploadFile(event.target.files[0].name);
      setUploadedUrl(event.target.files[0]);
    } else {
      toast.error("File size should be less than 5MB", {
        toastId: 7,
      });
    }
  };
  const titles = ["Type", "Expiry", "Uploaded By", "Actions"];
  const handleDownload = async (url, file) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = singleinvintDetails.business_name + "_" + file; // file name
      a.click();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.log(err);
    }
  };
  const handleChangeDownload = async () => {
    const fileUrl = URL.createObjectURL(url);
    window.open(fileUrl, "_blank");
  };
  let loanhistorydata = singleinvintDetails.loan_history;
  let loan_history_array = [];
  loanhistorydata?.map((each_history_record) => {
    // D8: records with their own description are shown as-is (generic events, waivers, closure).
    if (each_history_record.description) {
      loan_history_array.push({ message: loanEventMessage(each_history_record, { admin: true }), created_date_time: each_history_record.created_date_time });
      return;
    }
    //NEW LOAN REQUEST LIST
    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Business requested loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      !each_history_record.is_investor_interested &&
      !each_history_record.is_admin_sent_terms_to_business
    ) {
      if (
        each_history_record.status == STATUS_IN_PROGRESS &&
        each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
      ) {
        let message =
          "Admin filled the profit percentage and sent to investors";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time,
        };
        loan_history_array.push(message_object);
      }
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Admin rejected the new loan request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_IN_PROGRESS &&
      each_history_record.is_investor_interested === 1 &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Investor has shown interest on this loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_IN_PROGRESS &&
      each_history_record.is_admin_sent_terms_to_business === 1 &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Admin sent loan terms and awaiting for business response";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Business agreed the new loan request terms";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_PROCESSED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = (
        <div className="style_loan_txt">
          Admin paid the requested loan amount{" "}
          <span
            style={{ color: "black", marginTop: "2px" }}
            className="ps-1 pe-1 fw-bold"
          >
            {each_history_record.paid_currency +
              " " +
              Number(each_history_record.paid_amount).toLocaleString()}
          </span>{" "}
          to business on{" "}
          <span
            style={{ color: "black", marginTop: "2px" }}
            className="ps-1 pe-1 fw-bold"
          >
            {moment(each_history_record.paid_date).format("DD MMM YYYY")}
          </span>
        </div>
      );
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == LOAN_REPAYMENT_BY_BUSINESS &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = (
        <div className="">
          Business repaid for the month of{" "}
          <span style={{ color: "black" }} className="fw-bold">
            {moment(each_history_record.tenure_date).format("MMMM")}
          </span>
          , loan tenure amount{" "}
          <span style={{ color: "black" }} className="fw-bold">
            {each_history_record.paid_currency +
              " " +
              Number(each_history_record.paid_amount).toLocaleString()}
          </span>{" "}
          to admin on{" "}
          <span style={{ color: "black" }} className=" fw-bold">
            {moment(each_history_record.paid_date).format("DD MMM YYYY")}
          </span>
        </div>
      );
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    ) {
      let message = "Business requested to extend loan tenure";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    ) {
      let message = "Admin approved extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE
    ) {
      let message = "Admin rejected the extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }

    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
    ) {
      let message = "Business requested for pre closure of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
    ) {
      let message = "Admin approved pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE
    ) {
      let message = "Admin rejected pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Business requested for partial pre-payment of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin approved partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin rejected partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_CLOSED &&
      each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN
    ) {
      let message = "Business repaid the loan successfully";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
  });
  const [maxDate, setMaxDate] = useState('');
  
  useEffect(() => {
    const now = new Date();
    const today = now.toISOString().split('T')[0];
    const currentTime = now.getHours() * 3660 + now.getMinutes() * 60 + now.getSeconds();

    if (currentTime >= 0 && currentTime < 12 * 3660) {
      const tomorrow = new Date(now);
      tomorrow.setDate(now.getDate() + 1);
      const tomorrowDate = tomorrow.toISOString().split('T')[0];
      setMaxDate(tomorrowDate);
    } else {
      setMaxDate(today);
    }
   
  }, [selectedtype,defaultSelect]);
  const isLoanClosed = singleinvintDetails.status === STATUS_CLOSED;
  const isMultiInvestor = subscriptions.length > 0;
  const multiInvestorRequestId = isMultiInvestor ? subscriptions[0]?.investor_request_id : null;
  const activeSubs = subscriptions.filter((s) => s.status === SUBSCRIPTION_STATUS_ACTIVE);
  const multiInvestorCount = new Set((activeSubs.length > 0 ? activeSubs : subscriptions).map((s) => String(s.investor_id))).size;
  // A multi-investor loan that is still open / fully funded / disbursing has not been paid out yet:
  // show its funding stage in the header and keep Record Payment locked until disbursement completes.
  const PRE_DISBURSEMENT_LABEL = {
    [OPPORTUNITY_STATUS_OPEN]: "Open for Funding",
    [OPPORTUNITY_STATUS_FULLY_FUNDED]: "Fully Funded",
    [OPPORTUNITY_STATUS_DISBURSING]: "Disbursing",
  };
  // Fail closed: the opportunity status comes from get_breakdown (loans with subscriptions), the
  // caller (MultiInvestorOpportunities passes it, so an OPEN loan with 0 pledges is caught), or the
  // loan payload's investor_request_status when the backend provides it. Legacy loans opened from
  // other screens without any of these keep their old behaviour.
  const knownOpportunityStatus =
    opportunityStatus ?? singleinvintDetails.investor_request_status ?? props.opportunityStatus ?? null;
  const isPreDisbursement = !isLoanClosed && PRE_DISBURSEMENT_LABEL[knownOpportunityStatus] !== undefined;
  // Still verifying (or could not verify) whether the loan has been disbursed.
  const disbursementUnverified =
    !isLoanClosed &&
    !isPreDisbursement &&
    (subscriptionsState !== 'loaded' || (isMultiInvestor && opportunityStatus == null));
  const disbursementCheckFailed =
    subscriptionsState === 'failed' || (isMultiInvestor && opportunityStatus == null && opportunityStatusFailed);
  const recordPaymentLocked =
    singleinvintDetails.has_pending_investor_extension || singleinvintDetails.extension_fee_required || isLoanClosed || isPreDisbursement || disbursementUnverified;
  const recordPaymentLockReason = isLoanClosed
    ? "Loan is closed — view only"
    : isPreDisbursement
    ? "Loan not yet disbursed — record payment unlocks after disbursement"
    : disbursementUnverified
    ? disbursementCheckFailed
      ? "Could not verify the loan's disbursement status — reopen the loan to retry"
      : "Checking the loan's disbursement status…"
    : singleinvintDetails.has_pending_investor_extension
    ? "Extension pending investor approval — record payment is locked"
    : singleinvintDetails.extension_fee_required
    ? "Extension fee must be recorded before proceeding"
    : "";
  // One investor (possibly with several Fund Now investments) is named, not "Multiple investors (1)".
  const soleInvestorName =
    multiInvestorCount === 1
      ? (breakdownInvestors.find((i) => i.state !== "withdrawn") || breakdownInvestors[0])?.investor_name
      : null;
  const investorNameDisplay = isMultiInvestor
    ? multiInvestorCount === 1
      ? soleInvestorName || "1 investor"
      : `Multiple investors (${multiInvestorCount})`
    : singleinvintDetails.investor_name || "";
  return (
    <>
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header onHide={handleClose} closeButton className="modal_title">
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">Detailed View</h5>
            </div>
            <div className="head_fourdots">
              {isLoanClosed ? (
                <span
                  style={{
                    display: 'inline-block', background: '#EEF0F3', color: '#344054', fontWeight: 600,
                    fontSize: 13, padding: '5px 14px', borderRadius: 999, border: '1px solid #D0D5DD'
                  }}
                >
                  Loan Closed · view only
                </span>
              ) : isPreDisbursement ? (
                <h5 style={{ color: '#185FA5' }}>{PRE_DISBURSEMENT_LABEL[knownOpportunityStatus]}</h5>
              ) : disbursementUnverified ? (
                <h5 style={{ color: '#7C8495' }}>{disbursementCheckFailed ? 'Status unavailable' : 'Checking status…'}</h5>
              ) : (
                <>
                  <img src="./images/paymentprocessedStepper.svg" alt="" />
                  <h5 className="green-title ">Payment Processed</h5>
                </>
              )}
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className={`${loading ? "px-4" : "px-4 py-2"}`}
        style={{ maxHeight: '80vh', overflowY: 'auto' }}
      >
        <div className={loading ? "onClickApplyLoaderStyl" : ""}>
          <ThreeDots
            height="60"
            width="60"
            radius="9"
            color="#3d79f3"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={loading}
          />
        </div>
        <div className="row bg-white ">
          <div className="col">
            <ul className="nav nav-tabs d-flex" id="myTab" role="tablist">
              <li className="nav-item-indiv-busns" role="presentation">
                <button
                  className="nav-link-inv active p-0"
                  id="loandetails-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#loandetails-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="loandetails-tab-pane"
                  aria-selected="true"
                >
                  <h3>Loan Details</h3>
                </button>
              </li>
              {isMultiInvestor && (
                <li className="nav-item-indiv-busns" role="presentation">
                  <button
                    className="nav-link-inv p-0"
                    id="investorbreakdown-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#investorbreakdown-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="investorbreakdown-tab-pane"
                    aria-selected="false"
                  >
                    <h3>Investor Breakdown</h3>
                  </button>
                </li>
              )}
              {/* Schedules, waivers and repayments only exist once the loan is disbursed (QA #8). */}
              {!isPreDisbursement && (
              <li className="nav-item-indiv-busns" role="presentation">
                <button
                  className="nav-link-inv p-0"
                  id="paymentdetails-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#paymentdetails-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="paymentdetails-tab-pane"
                  aria-selected="false"
                >
                  <h3>Payment Details</h3>
                </button>
              </li>
              )}

              <li className="nav-item-indiv-busns" role="presentation">
                <button
                  className="nav-link-inv p-0"
                  id="charges-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#charges-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="charges-tab-pane"
                  aria-selected="false"
                >
                  <h3>Additional Charges</h3>
                </button>
              </li>
              <li className="nav-item-indiv-busns" role="presentation">
                <button
                  className="nav-link-inv p-0"
                  id="documents-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#documents-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="documents-tab-pane"
                  aria-selected="false"
                >
                  <h3>Documents</h3>
                </button>
              </li>
              <li className="nav-item-indiv-busns" role="presentation">
                <button
                  className="nav-link-inv p-0"
                  id="loanhistory-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#loanhistory-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="loanhistory-tab-pane"
                  aria-selected="false"
                >
                  <h3>Loan History</h3>
                </button>
              </li>
            </ul>
          </div>

          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active line_height_about_inv"
              id="loandetails-tab-pane"
              role="tabpanel"
              aria-labelledby="loandetails-tab"
              tabIndex="0"
            >
              {
                dataloading ? (
                <div className="loader d-flex justify-content-center mt-5">
                  <ThreeDots
                    height="80"
                    width="80"
                    radius="9"
                    color="#3D79F3"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </div>
              ) : (
                <div>
                  <div className="container p-0 mb-4">
                    <div className="row">
                      <div className="col-lg-5">
                        <div className="mb-3">
                          <p className="text_st ">Business Name</p>
                          <span className="bolder_text ">
                            {singleinvintDetails.business_name !== undefined ||
                            singleinvintDetails.business_name !== ""
                              ? singleinvintDetails.business_name
                              : ""}
                          </span>
                        </div>
                      </div>
                      <div className="col">
                        <div className="mb-3">
                          <p className="text_st ">Investor Name</p>
                          <span className="bolder_text ">
                            {investorNameDisplay}
                          </span>
                        </div>
                      </div>
                      <div className="col">
                        <div className="mb-3">
                          <p className="text_st ">Status</p>
                          <span className="bolder_text ">
                            {singleinvintDetails.status !== "" ||
                            singleinvintDetails.status !== undefined
                              ? singleinvintDetails.status === STATUS_PROCESSED
                                ? "Processed"
                                : singleinvintDetails.status === STATUS_CLOSED
                                ? "Closed"
                                : singleinvintDetails.status === STATUS_IN_PROGRESS
                                ? "In Progress"
                                : ""
                              : ""}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="container p-0 pb-3">
                    <div className="row">
                      <div className="col ">
                        <div className="mb-3">
                          <p className="text_st ">Service type</p>
                          <span className="bolder_text ">
                            {/* QA #45: every service type, not just New Loan. */}
                            {{
                              [SERVICE_REQUEST_NEW_LOAN]: "New Loan",
                              [SERVICE_REQUEST_EXTEND_TENURE]: "Extend Tenure",
                              [SERVICE_REQUEST_PRE_CLOSURE]: "Pre Closure",
                              [SERVICE_REQUEST_PARTIAL_PRE_PAYMENT]: "Partial Pre-payment",
                            }[Number(singleinvintDetails.service_type_code)] || "-"}
                          </span>
                        </div>
                        <div className="mb-3">
                          <p className="text_st ">Amount Borrowed</p>
                          {/* QA #31/#36: the approved amount (or the reduced amount after funding was
                              closed early), with the originally requested amount underneath. */}
                          {(() => {
                            const cur = singleinvintDetails.admin_request_loan_currency === LOAN_CURRENCY_TYPE_BHD ? "BHD " : "$\u00A0";
                            const approved = Number(singleinvintDetails.approved_loan_amount);
                            const requested = Number(singleinvintDetails.loan_amount);
                            const shown = approved > 0 ? approved : requested;
                            return (
                              <>
                                <span className="bolder_text ">{cur + shown.toLocaleString()}</span>
                                {approved > 0 && requested > 0 && approved !== requested && (
                                  <div style={{ fontSize: 11, color: "#7C8495" }}>Requested: {cur + requested.toLocaleString()}</div>
                                )}
                              </>
                            );
                          })()}
                        </div>
                        <div className="mb-3">
                          <p className="text_st ">Principal Frequency</p>
                          <span className="bolder_text ">
                            {singleinvintDetails.principal_frequency}
                          </span>
                        </div>
                      </div>
                      <div className="col">
                        <div className="mb-3">
                          <p className="text_st ">Service Reference No.</p>
                          <span className="bolder_text ">
                            {singleinvintDetails.service_request_reference_no}
                          </span>
                        </div>
                        <div className="mb-3">
                          <p className="text_st ">Return Rate</p>
                          <span className="bolder_text ">
                            {singleinvintDetails.bennefin_roi === undefined
                              ? "-"
                              : singleinvintDetails.bennefin_roi + "%"}
                          </span>
                        </div>
                        <div className="mb-3">
                          <p className="text_st ">Investor ROI</p>
                          <span className="bolder_text ">
                            {singleinvintDetails.investor_roi + "%"}
                          </span>
                        </div>
                      </div>
                      <div className="col">
                        <div className="mb-3">
                          <p className="text_st ">Loan Type</p>
                          <span className="bolder_text ">
                            {singleinvintDetails.loan_type_name === undefined
                              ? "-"
                              : singleinvintDetails.loan_type_name}
                          </span>
                        </div>
                        <div className="mb-3">
                          <p className="text_st ">Grade</p>
                          <span className="bolder_text ">
                            {singleinvintDetails.rating === 1
                              ? "A"
                              : singleinvintDetails.rating === 2
                              ? "B"
                              : singleinvintDetails.rating === 3
                              ? "C"
                              : "D"}
                          </span>
                        </div>
                        <div className="mb-3">
                          <p className="text_st ">Processing Fee Type</p>
                          <span className="bolder_text ">
                            {singleinvintDetails.processing_fees_type}
                          </span>
                        </div>
                      </div>
                      <div className="col">
                        <div className="mb-3">
                          <p className="text_st ">Requested Tenure Period</p>
                          <span className="bolder_text ">
                            {singleinvintDetails.admin_request_loan_tenure ===
                              undefined ||
                            singleinvintDetails.admin_request_loan_tenure === ""
                              ? "No Data"
                              : singleinvintDetails.admin_request_loan_tenure ===
                                1
                              ? singleinvintDetails.admin_request_loan_tenure +
                                " Month"
                              : singleinvintDetails.admin_request_loan_tenure +
                                " Months"}
                          </span>
                        </div>
                        <div className="mb-3">
                          <p className="text_st ">Interest Frequency</p>
                          <span className="bolder_text ">
                            {singleinvintDetails.interest_frequency}
                          </span>
                        </div>
                        <div className="mb-3">
                          <p className="text_st ">Processing Fee</p>
                          <span className="bolder_text ">
                            {singleinvintDetails.admin_request_loan_currency ===
                            LOAN_CURRENCY_TYPE_BHD
                              ? "BHD "
                              : "$\u00A0"}
                            {singleinvintDetails.processing_fees}
                          </span>
                        </div>
                      </div>
                      <div className="mb-3">
                        <p className="text_st ">Loan Purpose</p>
                        <div className="loan_purps_notes">
                          <span className="bolder_text ">
                            {singleinvintDetails.loan_purpose === undefined
                              ? "-"
                              : singleinvintDetails.loan_purpose}
                          </span>
                        </div>
                      </div>
                      <div className="mb-3">
                        <p className="text_st ">Collateral</p>
                        <span className="bolder_text ">
                          {singleinvintDetails.collateral
                            ? singleinvintDetails.collateral
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {isLoanClosed ? (
                    <div
                      className="p-3 mb-3"
                      style={{ border: '1px solid #DADDE3', borderRadius: 8, background: '#FAFAF9' }}
                    >
                      <table className="table" style={{ fontSize: 13, marginBottom: 0 }}>
                        <tbody>
                          <tr>
                            <td style={{ width: '40%', color: '#7C8495' }}>Status</td>
                            <td style={{ fontWeight: 700 }}>Closed — view only</td>
                          </tr>
                          <tr>
                            <td style={{ color: '#7C8495' }}>Closure date</td>
                            <td style={{ fontWeight: 700 }}>
                              {singleinvintDetails.closed_date_time
                                ? moment(Number(singleinvintDetails.closed_date_time)).format('DD MMM YYYY, HH:mm')
                                : '-'}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ color: '#7C8495' }}>Closed by</td>
                            <td style={{ fontWeight: 700 }}>{singleinvintDetails.closed_by || '-'}</td>
                          </tr>
                        </tbody>
                      </table>
                      <p style={{ fontSize: 11, color: '#7C8495', marginTop: 10, marginBottom: 0 }}>
                        No financial, status, or record changes are permitted on this loan.
                        Corrections after closure go through a separate adjustment process, not by editing here.
                      </p>
                    </div>
                  ) : roleCode !== AUDITOR_ROLE && (
                    <div
                      className="p-3 mb-3"
                      style={{ border: '1px solid #DADDE3', borderRadius: 8, background: '#FAFAF9' }}
                    >
                      <h6 style={{ marginBottom: 10 }}>Loan Closure — manual only, no auto-close</h6>
                      {closureEligibilityLoading ? (
                        <div style={{ fontSize: 12, color: '#7C8495' }}>Checking outstanding amounts…</div>
                      ) : closureEligibility ? (
                        <>
                          <table className="table table-sm" style={{ fontSize: 13 }}>
                            <thead>
                              <tr>
                                <th>Business due</th>
                                <th>Investor due</th>
                                <th>Tenures verified</th>
                                <th>Charges outstanding</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{closureEligibility.business_due === null || closureEligibility.business_due === undefined ? '—' : <>{singleinvintDetails.admin_request_loan_currency || 'BHD'}{"\u00A0"}{Number(closureEligibility.business_due).toFixed(2)}</>}</td>
                                {/* The investor-side check runs on the USD payout rows; a settled (zero) due is shown in
                                    the loan's currency so a BHD loan doesn't read "USD 0.00". */}
                                {/* QA #33: in the loan's currency, and nothing to show before the loan is disbursed. */}
                                <td>
                                  {isPreDisbursement || closureEligibility.investor_due_loan_currency === null || closureEligibility.investor_due_loan_currency === undefined
                                    ? '—'
                                    : <>{singleinvintDetails.admin_request_loan_currency || 'BHD'}{"\u00A0"}{Math.max(0, Number(closureEligibility.investor_due_loan_currency)).toFixed(2)}</>}
                                </td>
                                <td>{closureEligibility.all_tenures_checked ? 'Yes' : 'No'}</td>
                                <td>{closureEligibility.unsettled_charges?.length || 0}</td>
                              </tr>
                            </tbody>
                          </table>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                            <button
                              className="btn blue_btn px-3 py-1"
                              style={{ fontSize: 13 }}
                              disabled={!closureEligibility.isSettled}
                              onClick={handleOpenCloseLoanModal}
                            >
                              Close Loan
                            </button>
                            {!closureEligibility.isSettled && (
                              <span style={{ fontSize: 11.5, color: '#A32D2D' }}>
                                Cannot close yet:{' '}
                                {(closureEligibility.blockers && closureEligibility.blockers.length
                                  ? closureEligibility.blockers
                                  : ['principal, interest, penalties, fees or additional charges remain outstanding']
                                ).join('; ')}.
                              </span>
                            )}
                          </div>
                        </>
                      ) : null}
                      <p style={{ fontSize: 11, color: '#7C8495', marginTop: 10, marginBottom: 0 }}>
                        Closed loans become view-only — no edits/deletes on any record. Corrections after closure
                        go through a separate adjustment process, not by editing here.
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>

            {isMultiInvestor && (
              <div
                className="tab-pane fade"
                id="investorbreakdown-tab-pane"
                role="tabpanel"
                aria-labelledby="investorbreakdown-tab"
                tabIndex="0"
              >
                {multiInvestorRequestId ? (
                  <InvestorBreakdownTab
                    key={multiInvestorRequestId}
                    investorRequestId={multiInvestorRequestId}
                    isLoanClosed={isLoanClosed}
                    roleCode={roleCode}
                    onChanged={refreshLoanDetails}
                    onLoaded={(b) => setOpportunityStatus(b?.status ?? null)}
                  />
                ) : (
                  <div className="p-3" style={{ fontSize: 13, color: "#7C8495" }}>
                    No opportunity is linked to these subscriptions.
                  </div>
                )}
              </div>
            )}

            <div
              className="tab-pane fade Financials_tab"
              id="paymentdetails-tab-pane"
              role="tabpanel"
              aria-labelledby="paymentdetails-tab"
              tabIndex="0"
            >
              <div>
                <div className="row bg-white ">
                  <div className="col">
                    <ul
                      className="nav nav-tabs d-flex"
                      id="myTab"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <button
                          className={`nav-link p-0 admin_PD_tabs me-3 ${
                            activeTab === "paymentScheduledetails-tab"
                              ? "active"
                              : ""
                          }`}
                          id="paymentScheduledetails-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#paymentScheduledetails-tab-pane"
                          type="button"
                          role="tab"
                          aria-controls="paymentScheduledetails-tab-pane"
                          aria-selected="false"
                          onClick={() => {
                            setActiveTab("paymentScheduledetails-tab")
                            setPenaltyBreakdown(null)
                            setEnteredpenaltyAmount(null)
                            setFilterDate("")
                            setPaidDate("")
                            setEnteredAmount(null)
                            setSelectedType("")
                            setDefaultSelect(true)
                          }}                        >
                          <h6>Payment Details and Schedules</h6>
                          {activeTab === "paymentScheduledetails-tab" && (
                            <img
                              style={{ marginTop: "-48px" }}
                              src="./images/polygondown.svg"
                              alt=""
                            />
                          )}
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className={`nav-link admin_PD_tabs  p-0 ${
                            activeTab === "recordpayment-tab" ? "active" : ""
                          }`}
                          id="recordpayment-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#recordpayment-tab-pane"
                          type="button"
                          role="tab"
                          aria-controls="recordpayment-tab-pane"
                          aria-selected="true"
                          disabled={recordPaymentLocked}
                          onClick={() => !recordPaymentLocked && setActiveTab("recordpayment-tab")}
                          title={recordPaymentLockReason}
                          style={recordPaymentLocked ? { opacity: 0.4, cursor: 'not-allowed' } : {}}
                        >
                          <h6>Record Payment {recordPaymentLocked && <span style={{ fontSize: 9, color: '#E24B4A' }}>🔒</span>}</h6>
                          {activeTab === "recordpayment-tab" && (
                            <img
                              style={{ marginTop: "-48px" }}
                              src="./images/polygondown.svg"
                              alt=""
                            />
                          )}
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div
                    className="tab-content align-items-center"
                    id="myTabContent"
                  >
                    <div
                      className={`tab-pane fade show ${
                            activeTab === "paymentScheduledetails-tab"
                              ? "active"
                              : ""
                          }  mt-3 `}
                      id="paymentScheduledetails-tab-pane"
                      role="tabpanel"
                      aria-labelledby="paymentScheduledetails-tab"
                      tabIndex="0"
                    >
                      <div className="row mt-3">
                        <div className="col">
                          <p className="text_st">Business Name</p>
                          <div className="bolder_text">
                            {singleinvintDetails.business_name}
                          </div>
                        </div>
                        <div className="col me-2 ms-2">
                          <p className="text_st">Investor Name</p>
                          <div className="bolder_text">
                            {investorNameDisplay}
                          </div>
                        </div>
                        <div className="col">
                          <p className="text_st">Status</p>
                          <div className="bolder_text">
                            {singleinvintDetails.status === STATUS_PROCESSED
                              ? "Processed"
                              : singleinvintDetails.status === STATUS_CLOSED
                              ? "Closed"
                              : ""}
                          </div>
                        </div>
                      </div>
                      <div className="mt-3 d_view_table">
                        <Table striped>
                          <thead>
                            <tr>
                              {singleInvTableData === "" ||
                              singleInvTableData === undefined ? (
                                <div className="text-center fw-bold fs-6 mt-2">
                                  No Records
                                </div>
                              ) : (
                                columns.map((data, id) => (
                                  <th className="bg-white" key={id}>{data.title}</th>
                                ))
                              )}
                            </tr>
                          </thead>
                          <tbody className="">
                            {singleInvTableData?.map((data, index) => {
                              return (
                                <tr key={index}>
                                  <td className="txt">
                                    {data.admin_request_loan_currency ===
                                    LOAN_CURRENCY_TYPE_USD
                                      ? "$\u00A0"
                                      : "BHD "}
                                    {Number(
                                      data.tenure_amount
                                    ).toLocaleString()}
                                  </td>
                                  <td className="txt text-start">
                                    {moment(data.tenure_date).format(
                                      "DD MMM YYYY"
                                    )}
                                  </td>
                                  <td
                                    className="txt"
                                    selected={data.paid_amount}
                                  >
                                    <div class="d-flex gap-1">
                                      <div>
                                        {data.admin_request_loan_currency ===
                                        LOAN_CURRENCY_TYPE_USD
                                          ? "$\u00A0"
                                          : "BHD "}
                                      </div>
                                      {data.is_selected === false ? (
                                        data.paid_amount
                                      ) : (
                                        <div className="form-group ">
                                          <InputGroup className="pymnt_dtls_amt_edit_field">
                                            <Form.Control
                                              type="number"
                                              className="rounded  shadow-ben  "
                                              id="bennefin"
                                              name="paidAmt"
                                              required
                                              role="presentation"
                                              autoComplete="off"
                                              defaultValue={Number(
                                                data.paid_amount
                                              )}
                                              disabled={userId!==fetchedUserId}
                                              // placeholder={data.paid_amount}
                                              onChange={(e) =>
                                                handleEditAmtPaid(
                                                  e,
                                                  data.payment_schedule_id
                                                )
                                              }
                                            />
                                          </InputGroup>
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                  <td
                                    className="txt"
                                    selected={Number(data.penalty_amount)}
                                  >
                                    {
                                      <div class="d-flex gap-1">
                                        <div>
                                          {data.admin_request_loan_currency ===
                                          LOAN_CURRENCY_TYPE_USD
                                            ? "$\u00A0"
                                            : "BHD "}
                                        </div>
                                        {data.is_selected === false ? (
                                          isNaN(data.penalty_amount) ? (
                                            ''
                                          ) : (
                                            data.penalty_amount
                                          )
                                        ) : (
                                          <div className="form-group ">
                                            <InputGroup className="pymnt_dtls_amt_edit_field">
                                              <Form.Control
                                                type="number"
                                                className="rounded  shadow-ben  "
                                                id="bennefin"
                                                name="paidAmt"
                                                required
                                                role="presentation"
                                                autoComplete="off"
                                                disabled={userId!==fetchedUserId}
                                                defaultValue={Number(
                                                  data.penalty_amount
                                                )}
                                             
                                                onChange={(e) =>
                                                  handlePenaltyAmt(
                                                    e,
                                                    data.payment_schedule_id,
                                                    data.penalty_amount
                                                  )
                                                }
                                              />
                                            </InputGroup>
                                          </div>
                                        )}
                                      </div>
                                    }
                                  </td>

                                  <td className="cursor-pointer txt align-items-center">
                                    {data.is_business_repaid_to_bennefin ===
                                      0 && data.is_tenure_checked === 0 && Number(data.tenure_amount) > 0 ? (
                                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <span>-</span>
                                        {singleinvintDetails.has_pending_investor_extension || singleinvintDetails.extension_fee_required ? (
                                          <span style={{
                                            fontSize: 10,
                                            color: '#888',
                                            fontStyle: 'italic'
                                          }}>
                                            🔒 {singleinvintDetails.extension_fee_required ? 'Fee Required' : 'Locked'}
                                          </span>
                                        ) : Number(data.waived_amount) > 0 ? (
                                          <span style={{
                                            fontSize: 11,
                                            color: '#3B6D11',
                                            background: '#EAF3DE',
                                            border: '1px solid #C0DD97',
                                            borderRadius: 4,
                                            padding: '2px 6px'
                                          }}>
                                            Waived
                                          </span>
                                        ) : roleCode === AUDITOR_ROLE ? (
                                          // Auditors are read-only: applying a waiver is a write.
                                          <span>-</span>
                                        ) : (
                                          <span
                                            style={{
                                              cursor: 'pointer',
                                              fontSize: 11,
                                              color: '#185FA5',
                                              fontWeight: 500,
                                              textDecoration: 'underline'
                                            }}
                                            onClick={() => onWaiverClick(data)}
                                          >
                                            Waiver
                                          </span>
                                        )}
                                      </div>
                                    ) : data.is_business_repaid_to_bennefin ===
                                        1 && data.is_tenure_checked === 0 ? (
                                      <div>
                                        {data.color === "black" ? (
                                          <img
                                            src="./images/pen.svg"
                                            alt=""
                                            onClick={() => {
                                              setFetchedUserId(data?.admin_user_id);
                                              onPenClick(data.payment_schedule_id);
                                            }}
                                          />
                                        ) : data.color === "red" ? (
                                          <img
                                            src="./images/cancelMark.svg"
                                            alt=""
                                            onClick={() =>
                                              handleCancelClick(
                                                data.payment_schedule_id
                                              )
                                            }
                                          />
                                        ) : data.color === "green" ? (
                                          <i
                                            class="fa-solid fa-thumbs-up text-success fs-5"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Already verified"
                                          />
                                        ) : (
                                          <div class="gap-1">
                                            <img
                                              style={{
                                                width: "15px", 
                                                display: repaidAmountvalue <0 ||
                                                repaidAmountvalue =='' || 
                                                penaltyAmountValue =='' || 
                                                 penaltyAmountValue < 0
                                                    ? "none"
                                                    
                                                    : "",
                                              }}
                                              className="me-3"
                                              disabled={
                                                repaidAmountvalue < 0
                                                  ? true
                                                  : false
                                              }
                                              src={"./images/rightMark.svg"}
                                              alt=""
                                              onClick={() =>
                                                handleRightClick(
                                                  data.payment_schedule_id
                                                )
                                              }
                                            />
                                            <img
                                              style={{ width: "13px" }}
                                              src="./images/cancelMark.svg"
                                              alt=""
                                              onClick={() =>
                                                handleCancelClick(
                                                  data.payment_schedule_id
                                                )
                                              }
                                            />
                                          </div>
                                        )}
                                      </div>
                                    ) : data.is_business_repaid_to_bennefin ===
                                        1 && data.is_tenure_checked === 1 &&
                                        // QA #39: a waived tenure is fully settled at paid + waived = tenure.
                                        Number(data.paid_amount) + Number(data.waived_amount || 0) >= Number(data.tenure_amount) - 1 ? (
                                      <i
                                        class="fa-solid fa-thumbs-up text-success fs-5"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Already verified"
                                      />
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </div>

                    <div
                      className={`tab-pane fade show   mt-3 ${
                            activeTab === "recordpayment-tab" ? "active" : ""
                          }`}
                      id="recordpayment-tab-pane"
                      role="tabpanel"
                      aria-labelledby="recordpayment-tab"
                      tabIndex="0"
                      style={{ overflowY: 'auto', paddingBottom: 16 }}
                    >
                      <div className="row">
                        <div className="form-group col-lg-3 custm_input_styl">
                          <label htmlFor="tenuredate">
                            <p className="">
                              Tenure Date{" "}
                              <span style={{ color: "red" }}>*</span>
                            </p>
                          </label>
                          <select
                            id="tenuredate"
                            name="tenuredate"
                            className="form-select  shadow-sm APNL_option_flds"
                            aria-label="form-select example"
                            onChange={handleChangeInput}
                            disabled={roleCode===AUDITOR_ROLE}
                          >
                            <option selected={defaultSelect}>Select</option>
                            {getTenureDates?.map((dates, index) => {
                              return (
                                <option key={index}>
                                  {moment(dates.tenure_date).format(
                                    "DD MMM YYYY"
                                  )}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <div className="col-lg-3">
                          <form className="form-group col m-2 mt-0 ms-4 custm_input_styl aksjdhf">
                            <label htmlFor="duepayment">
                              <p>Due Payment </p>
                            </label>
                            <input
                              disabled
                              type="text"
                              name="duepayment"
                              id="disabledTextInput"
                              className="form-control bg-white"
                              placeholder={
                                filterDate?.due_amount !== undefined
                                  ? filterDate?.admin_request_loan_currency ===
                                    LOAN_CURRENCY_TYPE_USD
                                    ? "$\u00A0" + filterDate?.due_amount
                                    : "BHD " + filterDate?.due_amount
                                  : ""
                              }
                            />
                          </form>
                        </div>
                      </div>

                      <div className="contianer p-0 d-flex">
                        <div className="form-group me-3 custm_brdr">
                          <label htmlFor="paiddate">
                            <p>
                              Paid Date <span style={{ color: "red" }}>*</span>
                            </p>
                          </label>
                          <input
                            name="paiddate"
                            id="paiddate"
                            type="date"
                            max={maxDate}
                            value={paidDate?moment(paidDate).format("YYYY-MM-DD"):""}
                            className="form-control rounded payemnt_details_BS_form_conrtl"
                            onChange={handleChangeInput}
                            disabled={roleCode===AUDITOR_ROLE}

                          />
                        </div>
                        <div className="form-group ms-3">
                          <label htmlFor="paidamount">
                            <p>
                              Paid Amount{"  "}
                              <span style={{ color: "red" }}>*</span>
                            </p>
                          </label>
                          <InputGroup className="mb-3 payemnt_details_BS_form_conrtl">
                            <Form.Control
                              type="number"
                              className="rounded  shadow-ben px-3 "
                              id="bennefin"
                              name="paidamount"
                              placeholder=""
                              required
                              role="presentation"
                              autoComplete="off"
                              value={enteredAmount}
                              onChange={handleChangeInput}
                              disabled={roleCode===AUDITOR_ROLE}

                            />
                            <InputGroup.Text
                              className="paymnt_details_amt"
                              id="basic-addon2"
                            >
                              <p className="Payment_currency">
                                {filterDate?.admin_request_loan_currency === LOAN_CURRENCY_TYPE_USD
                                  ? "$"
                                  : filterDate?.admin_request_loan_currency === LOAN_CURRENCY_TYPE_BHD
                                    ? "BHD"
                                    : ""}
                              </p>
                            </InputGroup.Text>
                          </InputGroup>
                        </div>


                        {/* <div className="form-group ms-3">
                          <label htmlFor="penaltyamount">
                            <p className="ps-1">Excess Due</p>
                          </label>
                          <InputGroup className="mb-3 payemnt_details_BS_form_conrtl w-50">
                            <input
                              type="number"
                              className="form-control rounded shadow-ben px-3"
                              id="bennefin"
                              name="penaltyamount"
                              placeholder=""
                              required
                              role="presentation"
                              autoComplete="off"
                              onChange={handleChangeInput}
                              onInput={(e) => {
                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 10)
                              }}
                              disabled={roleCode === AUDITOR_ROLE}
                            />
                            <InputGroup.Text className="paymnt_details_amt" id="basic-addon2">
                              <p className="Payment_currency">
                                {filterDate?.admin_request_loan_currency === LOAN_CURRENCY_TYPE_USD
                                  ? "$"
                                  : filterDate?.admin_request_loan_currency === LOAN_CURRENCY_TYPE_BHD
                                    ? "BHD"
                                    : ""}
                              </p>
                            </InputGroup.Text>
                          </InputGroup>
                        </div> */}
                        <div className="form-group ms-3">
                          <label htmlFor="penaltyamount">
                            <p className="ps-1">Excess Due</p>
                          </label>
                          <InputGroup className="mb-3 payemnt_details_BS_form_conrtl w-50">
                            <input
                              type="number"
                              className="form-control rounded shadow-ben px-3 bg-white"
                              id="bennefin"
                              name="penaltyamount"
                              placeholder={penaltyLoading ? "Calculating..." : "0"}
                              readOnly
                              value={enteredpenaltyamount || 0}
                              disabled={roleCode === AUDITOR_ROLE}
                            />
                            <InputGroup.Text className="paymnt_details_amt" id="basic-addon2">
                              <p className="Payment_currency">
                                {filterDate?.admin_request_loan_currency === LOAN_CURRENCY_TYPE_USD
                                  ? "$"
                                  : filterDate?.admin_request_loan_currency === LOAN_CURRENCY_TYPE_BHD
                                    ? "BHD"
                                    : ""}
                              </p>
                            </InputGroup.Text>
                          </InputGroup>

                          {/* Penalty Box — shown only when there is a penalty */}
                          {penaltyBreakdown && penaltyBreakdown.days_late > 0 && (
                            <div style={{
                              border: '1px solid #F09595',
                              borderRadius: 8,
                              padding: '10px 14px',
                              background: '#FEF6F6',
                              fontSize: 12,
                              width: '260px',
                              marginTop: 4
                            }}>
                              <div style={{ fontWeight: 600, color: '#A32D2D', marginBottom: 8, fontSize: 12 }}>
                                Penalty Breakdown
                              </div>
                              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                <span style={{ color: '#555' }}>Days late</span>
                                <span style={{ fontWeight: 500 }}>{penaltyBreakdown.days_late} days</span>
                              </div>
                              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                <span style={{ color: '#555' }}>Tier 1 ({penaltyBreakdown.tier1_days}d × {penaltyBreakdown.monthly_rate}%)</span>
                                <span style={{ fontWeight: 500 }}>BHD {Number(penaltyBreakdown.tier1_penalty).toFixed(2)}</span>
                              </div>
                              {penaltyBreakdown.tier2_days > 0 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                  <span style={{ color: '#555' }}>Tier 2 ({penaltyBreakdown.tier2_days}d × {penaltyBreakdown.escalated_rate || (penaltyBreakdown.monthly_rate + penaltyBreakdown.tier2_rate)}%)</span>
                                  <span style={{ fontWeight: 500 }}>BHD {Number(penaltyBreakdown.tier2_penalty).toFixed(2)}</span>
                                </div>
                              )}
                              {Number(penaltyBreakdown.already_charged) > 0 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                  <span style={{ color: '#555' }}>Already charged on this tenure</span>
                                  <span style={{ fontWeight: 500 }}>− BHD {Number(penaltyBreakdown.already_charged).toFixed(2)}</span>
                                </div>
                              )}
                              <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #F09595', paddingTop: 6, marginTop: 4 }}>
                                <span style={{ fontWeight: 600, color: '#A32D2D' }}>{Number(penaltyBreakdown.already_charged) > 0 ? 'This payment' : 'Total'}</span>
                                <span style={{ fontWeight: 600, color: '#A32D2D' }}>BHD {Number(penaltyBreakdown.penalty_amount).toFixed(2)}</span>
                              </div>
                            </div>
                          )}

                          {penaltyBreakdown && penaltyBreakdown.days_late <= 0 && (
                            <div style={{ fontSize: 11, color: '#3B6D11', marginTop: -6 }}>
                              ✓ No penalty — paid on time
                            </div>
                          )}

                          {/* Open waiver modal from Record Payment tab */}
                          {filterDate?.payment_schedule_id && (
                            Number(filterDate?.waived_amount) > 0 ? (
                              <div style={{
                                fontSize: 11,
                                color: '#3B6D11',
                                background: '#EAF3DE',
                                border: '1px solid #C0DD97',
                                borderRadius: 6,
                                padding: '4px 10px',
                                marginTop: 6,
                                display: 'inline-block'
                              }}>
                                ✓ Waiver already applied for this month
                              </div>
                            ) : (
                              <button
                                className="btn btn-sm mt-2"
                                style={{
                                  fontSize: 11,
                                  color: '#185FA5',
                                  border: '1px solid #185FA5',
                                  borderRadius: 6,
                                  padding: '3px 10px',
                                  background: 'white'
                                }}
                                onClick={() => {
                                  setWaiverSchedule({
                                    ...filterDate,
                                    penalty_amount: penaltyBreakdown?.total_penalty ?? penaltyBreakdown?.penalty_amount ?? filterDate?.penalty_amount ?? 0
                                  })
                                  setWaiverType('none')
                                  setWaiverAmount(0)
                                  setWaiverReason('')
                                  setWaiverPreview(null)
                                  setWaiverConfirmed(false)
                                  setShowWaiverModal(true)
                                }}
                              >
                                Apply Waiver
                              </button>
                            )
                          )}

                        </div>

                      </div>

                      <div>
                        <h3>
                          Received Via{" "}
                          <span style={{ color: "red", fontSize: "1.2em" }}>
                            *
                          </span>
                        </h3>
                        <div className=" p-0 d-flex justify-content-between w-75">
                          {received_via_names?.map((element) => {
                            return (
                              <div
                                key={element}
                                className="admin_PD_radio_div row"
                              >
                                <label htmlFor={selectedtype !== element ? true : false}>
                                  <input
                                    className="PD_input_radio "
                                    id={selectedtype !== element ? true : false}
                                    type="radio"
                                    name="radio"
                                    checked={selectedtype === element ? true : false}
                                    // value={selectedtype ? selectedtype:""}
                                    onClick={() =>radioButtonMethodRating(element)}
                                    disabled={roleCode===AUDITOR_ROLE}
/>
                                  <span className="kyc_style_doc ps-2">
                                    {element}
                                  </span>
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      <div>
                        <h3 className="mt-4">Comments</h3>
                        <Form>
                          <Form.Group
                            className=" "
                            controlId="floatingTextarea"
                          >
                            <Form.Control
                              size="sm"
                              className="ANLtextarea custm_border_paymentdetails"
                              name="textarea"
                              as="textarea"
                              style={{ height: "50px", width: "95%" }}
                              rows={2}
                              value={comments}
                              placeholder="Please enter comments..."
                              onChange={handleChangeInputComments}
                              disabled={roleCode===AUDITOR_ROLE}
                              />
                          </Form.Group>
                        </Form>
                      </div>
                      <div className="d-flex gap-5">
                        <div className="attach_doc mt-3">
                          <label className="Cpointer padding_style">
                            <input
                              type="file"
                              onChange={(e) => handleChange(e)}
                              disabled={roleCode===AUDITOR_ROLE}

                            />
                            <span className=" ps-3">Attach Document</span>
                          </label>
                        </div>
                        <div className="mt-3">
                          <div className="d-flex gap-5">
                            <div
                              className="upload_file_name"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title={file}
                            >
                              {file}
                            </div>
                            <a
                              style={{
                                display: "table-cell",
                                cursor: "pointer",
                              }}
                            >
                              {isUpload == true && (
                                <i
                                  className="fa-solid fa-eye text-primary fa-eye-font"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title="Click to view image"
                                  onClick={(e) => handleChangeDownload()}
                                />
                              )}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade loanhistory_tab"
              id="documents-tab-pane"
              role="tabpanel"
              aria-labelledby="documents-tab"
              tabIndex="0"
            >
              <div className="row allinv_doc_tab_styl">
                <div className=" pe-4">
                  <Table
                    responsive
                    striped
                    className=" my_loan_table "
                    style={{ maxHeight: "250px", overflow: "auto" }}
                  >
                    <thead>
                      <tr>
                        {documents?.length === 0 ? (
                          <div className="d-flex justify-content-center mt-3 fs-6 fw-bold">
                            No Documents
                          </div>
                        ) : (
                          titles.map((title, id) => <th key={id}>{title}</th>)
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {documents?.map((doc, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              {doc.document_type == undefined
                                ? "-"
                                : doc.document_type}
                            </td>
                            <td>
                              {doc.expiry_date == null ? "-" : doc.expiry_date}
                            </td>
                            <td>
                              {doc.created_by == undefined
                                ? "-"
                                : doc.created_by}
                            </td>
                            <td>
                              <div className="d-flex justify-content-center">
                                <div className="">
                                  <a
                                    style={{ display: "table-cell" }}
                                    href={doc.document_url}
                                    target="_blank"
                                  >
                                    <img
                                      src="./images/icons/blue_eye.svg"
                                      alt=""
                                    />
                                  </a>
                                </div>
                                <div
                                  className=" ps-3 Cpointer"
                                  onClick={() =>
                                    handleDownload(
                                      doc.document_url,
                                      doc.document_type
                                    )
                                  }
                                >
                                  <img src="./images/down.svg" alt="" />
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade CurrentLoanDetails_tab"
              id="loanhistory-tab-pane"
              role="tabpanel"
              aria-labelledby="loanhistory-tab"
              tabIndex="0"
            >
              <div className="detld_view_LH">
                {sortLoanHistory(loan_history_array).map((details) => {
                  return (
                    <div key={details.message} className="row pt-0">
                      <div className="style_loan">
                        <img
                          className="me-2"
                          src="./images/circle.svg"
                          alt=""
                          srcSet=""
                          height={16}
                          width={16}
                        />
                        {moment(details.created_date_time).format(
                          "ddd, D MMM YYYY, h:mm A"
                        )}
                      </div>
                      <div className="style_loan_txt mb-4 ms-4 pe-5">
                        {details.message}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* ── Additional Charges Tab ── */}
            <div
              className="tab-pane fade CurrentLoanDetails_tab"
              id="charges-tab-pane"
              role="tabpanel"
              aria-labelledby="charges-tab"
              tabIndex="0"
            >
              <div className="p-3">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="mb-0">Additional Charges</h6>
                  {roleCode !== AUDITOR_ROLE && !isLoanClosed && !isPreDisbursement && !disbursementUnverified && (
                    <button
                      className="btn blue_btn px-3 py-1"
                      style={{ fontSize: 13 }}
                      onClick={() => setShowChargeModal(true)}
                    >
                      + Add Charge
                    </button>
                  )}
                </div>

                {/* Charges Table */}
                {chargesLoading ? (
                  <div className="d-flex justify-content-center mt-3">
                    <ThreeDots height="40" width="40" radius="9" color="#3D79F3" ariaLabel="loading" visible={true} />
                  </div>
                ) : charges.length === 0 ? (
                  <div className="text-center text-muted mt-4" style={{ fontSize: 13 }}>
                    No additional charges recorded for this loan.
                  </div>
                ) : (
                  <div style={{ overflowX: 'auto', width: '100%' }}>
                    <table className="table table-striped" style={{ fontSize: 13, minWidth: 900, whiteSpace: 'nowrap' }}>
                      <thead>
                        <tr>
                          <th>Type</th>
                          <th>Amount</th>
                          <th>Investor Share</th>
                          <th>BenneFin Share</th>
                          <th>Description</th>
                          <th>Charge Date</th>
                          <th>Created By</th>
                          <th>Status</th>
                          <th>Settlement</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {charges.map((charge, index) => (
                          <tr key={index}>
                            <td>{charge.charge_type}</td>
                            <td>BHD {Number(charge.charge_amount).toFixed(2)}</td>
                            <td>
                              BHD {Number(charge.investor_allocation).toFixed(2)}
                              <span style={{ fontSize: 11, color: '#888', marginLeft: 4 }}>
                                ({charge.investor_percentage}%)
                              </span>
                            </td>
                            <td>
                              BHD {Number(charge.bennefin_allocation).toFixed(2)}
                              <span style={{ fontSize: 11, color: '#888', marginLeft: 4 }}>
                                ({charge.bennefin_percentage}%)
                              </span>
                            </td>
                            <td style={{ maxWidth: 200, whiteSpace: 'normal' }}>{charge.description || '—'}</td>
                            <td>{moment(charge.charge_date).format('DD MMM YYYY')}</td>
                            <td>{charge.created_by}</td>
                            <td>
                              {charge.is_checked === 1 ? (
                                <span style={{
                                  fontSize: 11, color: '#3B6D11',
                                  background: '#EAF3DE', border: '1px solid #C0DD97',
                                  borderRadius: 4, padding: '2px 6px'
                                }}>
                                  ✓ Verified by {charge.checked_by}
                                </span>
                              ) : (
                                <span style={{
                                  fontSize: 11, color: '#854F0B',
                                  background: '#FAEEDA', border: '1px solid #FAC775',
                                  borderRadius: 4, padding: '2px 6px'
                                }}>
                                  Pending Verification
                                </span>
                              )}
                            </td>
                            <td>
                              {charge.is_settled === 1 ? (
                                <span style={{
                                  fontSize: 11, color: '#3B6D11',
                                  background: '#EAF3DE', border: '1px solid #C0DD97',
                                  borderRadius: 4, padding: '2px 6px'
                                }}>
                                  ✓ Settled
                                </span>
                              ) : (
                                <span style={{ fontSize: 11, color: '#854F0B' }}>
                                  BHD {Number(charge.amount_paid || 0).toFixed(2)} / {Number(charge.charge_amount).toFixed(2)} paid
                                </span>
                              )}
                            </td>
                            <td>
                              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-start' }}>
                                {charge.is_checked === 0 &&
                                  String(charge.created_by_user_id) !== String(Cookies.get('admin_user_id')) &&
                                  !isLoanClosed && (
                                  <button
                                    className="btn btn-sm"
                                    style={{
                                      fontSize: 11, color: '#185FA5',
                                      border: '1px solid #185FA5', borderRadius: 4,
                                      padding: '2px 8px'
                                    }}
                                    onClick={() => handleCheckCharge(charge.loan_charge_id)}
                                  >
                                    Verify
                                  </button>
                                )}

                                {charge.is_settled !== 1 && !isLoanClosed && roleCode !== AUDITOR_ROLE && (
                                  recordPaymentChargeId === charge.loan_charge_id ? (
                                    <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                                      <input
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        value={recordPaymentAmount}
                                        onChange={e => setRecordPaymentAmount(e.target.value)}
                                        placeholder="Amount"
                                        style={{ width: 90, fontSize: 11, padding: '2px 6px' }}
                                      />
                                      <button
                                        className="btn btn-sm blue_btn"
                                        style={{ fontSize: 11, padding: '2px 8px' }}
                                        disabled={recordPaymentLoading}
                                        onClick={() => handleRecordChargePayment(charge.loan_charge_id)}
                                      >
                                        {recordPaymentLoading ? '...' : 'Save'}
                                      </button>
                                      <button
                                        className="btn btn-sm"
                                        style={{ fontSize: 11, padding: '2px 8px' }}
                                        onClick={() => { setRecordPaymentChargeId(null); setRecordPaymentAmount('') }}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  ) : (
                                    <button
                                      className="btn btn-sm"
                                      style={{
                                        fontSize: 11, color: '#3B6D11',
                                        border: '1px solid #C0DD97', borderRadius: 4,
                                        padding: '2px 8px'
                                      }}
                                      onClick={() => { setRecordPaymentChargeId(charge.loan_charge_id); setRecordPaymentAmount('') }}
                                    >
                                      Record Payment
                                    </button>
                                  )
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="d-flex  ps-3 pe-3">
        <div>
          <button
            className="btn btn_background mx-2 px-3 py-2"
            onClick={handleClose}
          >
            Close
          </button>
          <button
            className="btn blue_btn mx-2 px-3 py-2"
            style={isLoanClosed ? { display: 'none' } : {}}
            disabled={
              enteredAmount === undefined ||
              enteredAmount === "" ||
              enteredAmount === null ||
              paidDate === undefined ||
              paidDate === "" ||
              paidDate === null ||
              selectedtype === undefined ||
              selectedtype === "" ||
              filterDate?.tenure_date === "" ||
              filterDate?.tenure_date === undefined ||
              filterDate?.tenure_date === "Select"
                ? true
                : false
            }
            onClick={submitted}
          >
            Save
          </button>
        </div>
      </Modal.Footer>
   </Modal>

    <Modal
      show={showWaiverModal}
      onHide={() => setShowWaiverModal(false)}
      size="lg"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16, fontWeight: 500 }}>
          Apply Waiver
          {waiverSchedule && (
            <span style={{ fontSize: 12, color: '#888', marginLeft: 8 }}>
              Tenure: {moment(waiverSchedule.tenure_date).format('DD MMM YYYY')}
            </span>
          )}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', paddingBottom: 24 }}>
        <div style={{
          background: '#FCEBEB', border: '1px solid #F09595',
          borderRadius: 8, padding: '10px 14px', marginBottom: 16,
          fontSize: 12, color: '#A32D2D'
        }}>
          <strong>Strict Rule:</strong> Waivers apply exclusively to BenneFin's
          share. The investor's allocated share is fully protected and can never
          be waived under any circumstance.
        </div>

        <div className="form-group mb-3">
          <label style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>
            Waiver Type <span style={{ color: 'red' }}>*</span>
          </label>
          <select className="form-control" value={waiverType}
            onChange={e => handleWaiverTypeChange(e.target.value)}>
            <option value="none">Select waiver type</option>
            <option value="Interest Waiver">Interest Waiver</option>
            <option
              value="Penalty Waiver"
              disabled={!waiverSchedule?.penalty_amount || Number(waiverSchedule?.penalty_amount) === 0}
            >
              {`Penalty Waiver${(!waiverSchedule?.penalty_amount || Number(waiverSchedule?.penalty_amount) === 0) ? ' (no penalty)' : ''}`}
            </option>
            <option value="Full Waiver">Full Waiver</option>
            <option value="Partial Waiver">Partial Waiver</option>
          </select>
        </div>

        {waiverPreviewLoading && (
          <div style={{ fontSize: 12, color: '#888', marginBottom: 12 }}>
            Calculating...
          </div>
        )}

        {waiverPreview && waiverType !== 'none' && !waiverPreviewLoading && (
          <div style={{
            background: '#f8f9fa', border: '0.5px solid #dee2e6',
            borderRadius: 8, padding: '12px 16px', marginBottom: 16, fontSize: 13
          }}>
            <div style={{ fontWeight: 500, marginBottom: 10, fontSize: 14 }}>
              Waiver Breakdown
            </div>
            <div style={{
              display: 'grid', gridTemplateColumns: '1fr 1fr',
              gap: '8px 16px', marginBottom: 10
            }}>
              <div>
                <div style={{ color: '#888', fontSize: 12 }}>BenneFin spread (waivable)</div>
                <div style={{ fontWeight: 500 }}>
                  BHD {Number(waiverPreview.bennefin_spread).toFixed(2)}
                </div>
              </div>
              <div>
                <div style={{ color: '#888', fontSize: 12 }}>Investor interest (protected)</div>
                <div style={{ fontWeight: 500, color: '#3B6D11' }}>
                  BHD {Number(waiverPreview.investor_profit).toFixed(2)}
                </div>
              </div>
              <div>
                <div style={{ color: '#888', fontSize: 12 }}>Penalty amount</div>
                <div style={{ fontWeight: 500 }}>
                  BHD {Number(waiverPreview.penalty_amount).toFixed(2)}
                </div>
              </div>
              <div>
                <div style={{ color: '#888', fontSize: 12 }}>Max waivable amount</div>
                <div style={{ fontWeight: 500, color: '#185FA5' }}>
                  BHD {Number(waiverPreview.max_waivable_amount).toFixed(2)}
                </div>
              </div>
            </div>
            <div style={{
              borderTop: '0.5px solid #dee2e6', paddingTop: 10,
              display: 'flex', justifyContent: 'space-between',
              alignItems: 'center', flexWrap: 'wrap', gap: 8
            }}>
              <div>
                <div style={{ color: '#888', fontSize: 11 }}>Total payable (due + penalty)</div>
                <div style={{ fontWeight: 500 }}>
                  BHD {(Number(waiverPreview.original_tenure_amount) + Number(waiverPreview.penalty_amount)).toFixed(2)}
                </div>
              </div>
              <div style={{ color: '#888' }}>−</div>
              <div>
                <div style={{ color: '#888', fontSize: 11 }}>Waiver amount</div>
                <div style={{ fontWeight: 500, color: '#E24B4A' }}>
                  BHD {Number(waiverPreview.preview_waiver_amount).toFixed(2)}
                </div>
              </div>
              <div style={{ color: '#888' }}>=</div>
              <div>
                <div style={{ color: '#888', fontSize: 11 }}>Borrower pays</div>
                <div style={{
                  fontWeight: 500, fontSize: 16,
                  color: '#3B6D11'
                }}>
                  BHD {(Number(waiverPreview.original_tenure_amount) + Number(waiverPreview.penalty_amount) - Number(waiverPreview.preview_waiver_amount)).toFixed(2)}
                </div>
              </div>
            </div>
            {waiverPreview.is_over_waiver && (
              <div style={{
                marginTop: 10, padding: '8px 12px', background: '#FCEBEB',
                borderRadius: 6, color: '#A32D2D', fontSize: 12, fontWeight: 500
              }}>
                ⚠ Waiver amount exceeds max waivable amount.
                Investor share would be affected — submission blocked.
              </div>
            )}
          </div>
        )}

        {waiverType === 'Partial Waiver' && (
          <div className="form-group mb-3">
            <label style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>
              Waiver Amount (BHD) <span style={{ color: 'red' }}>*</span>
              {waiverPreview && (
                <span style={{ fontSize: 11, color: '#888', marginLeft: 6 }}>
                  Max: BHD {Number(waiverPreview.max_waivable_amount).toFixed(2)}
                </span>
              )}
            </label>
            <input
              type="number" className="form-control"
              value={waiverAmount} min={0}
              max={waiverPreview?.max_waivable_amount || 0}
              step={0.01}
              onChange={e => handleWaiverAmountChange(e.target.value)}
              placeholder="Enter waiver amount"
            />
          </div>
        )}

        <div className="form-group mb-3">
          <label style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>
            Approved By
          </label>
          <input
            type="text" className="form-control"
            value={Cookies.get('admin_user_name') || ''}
            readOnly style={{ background: '#f8f9fa', color: '#888' }}
          />
        </div>

        <div className="form-group mb-3">
          <label style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>
            Waiver Reason <span style={{ color: 'red' }}>*</span>
          </label>
          <textarea
            className="form-control" rows={3}
            value={waiverReason}
            onChange={e => setWaiverReason(e.target.value)}
            placeholder="Enter reason for waiver — mandatory for audit trail"
          />
        </div>

        <div style={{
          background: '#FAEEDA', border: '1px solid #FAC775',
          borderRadius: 8, padding: '10px 14px', marginBottom: 16,
          fontSize: 12, color: '#854F0B'
        }}>
          <strong>Warning:</strong> Once confirmed, a waiver cannot be reversed.
          Only a new adjustment entry can be added.
        </div>

        <div className="form-check mb-2" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <input
            type="checkbox"
            id="waiverConfirm"
            checked={waiverConfirmed}
            onChange={e => setWaiverConfirmed(e.target.checked)}
            style={{
              width: 16,
              height: 16,
              cursor: 'pointer',
              accentColor: '#185FA5'
            }}
          />
          <label htmlFor="waiverConfirm" style={{ fontSize: 13, cursor: 'pointer', marginBottom: 0 }}>
            I confirm this waiver has been authorised
          </label>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn_background px-4"
          onClick={() => setShowWaiverModal(false)}
          disabled={waiverLoading}>
          Cancel
        </button>
        <button className="btn blue_btn px-4"
          onClick={handleApplyWaiver}
          disabled={
            waiverLoading || waiverType === 'none' ||
            !waiverConfirmed || !waiverReason.trim() ||
            waiverPreview?.is_over_waiver
          }>
          {waiverLoading ? 'Applying...' : 'Apply Waiver'}
        </button>
      </Modal.Footer>
    </Modal>
          <Modal
      show={showChargeModal}
      onHide={() => setShowChargeModal(false)}
      size="lg"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16, fontWeight: 500 }}>
          Add Additional Charge
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
          <div className="row g-3">
            {/* Charge Type */}
            <div className="col-md-6">
              <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>
                Charge Type <span style={{ color: 'red' }}>*</span>
              </label>
              <select
                className="form-select"
                value={chargeType}
                onChange={e => setChargeType(e.target.value)}
              >
                <option value="">Select charge type</option>
                {chargeTypes.filter((t) => t !== 'Extension Fee' || singleinvintDetails.extension_fee_required).map((t, i) => (
                  <option key={i} value={t}>{t}</option>
                ))}
              </select>
            </div>

            {/* Charge Date */}
            <div className="col-md-6">
              <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>
                Charge Date <span style={{ color: 'red' }}>*</span>
              </label>
              <input
                type="date"
                className="form-control"
                value={chargeDate}
                max={new Date().toISOString().split('T')[0]}
                onChange={e => setChargeDate(e.target.value)}
              />
            </div>

            {/* Charge Amount */}
            <div className="col-md-6">
              <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>
                Charge Amount (BHD) <span style={{ color: 'red' }}>*</span>
              </label>
              <label style={{ fontSize: 11, color: 'transparent', display: 'block', marginBottom: 2 }}>
                placeholder
              </label>
              <input
                type="number"
                className="form-control"
                value={chargeAmount}
                min={0.01}
                step={0.01}
                onChange={e => {
                  const val = e.target.value
                  if (val === '' || Number(val) >= 0) setChargeAmount(val)
                }}
                onKeyDown={e => {
                  if (e.key === '-' || e.key === 'e') e.preventDefault()
                }}
                placeholder="0.00"
              />
            </div>

            {/* Investor Allocation */}
            <div className="col-md-6">
              <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>
                Investor Allocation
              </label>
              <div className="d-flex gap-2">
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: 11, color: '#888', display: 'block', marginBottom: 2 }}>
                    Percentage (%)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={investorAllocation}
                    min={0}
                    max={100}
                    step={0.01}
                    onChange={e => {
                      const val = e.target.value
                      if (val === '' || (Number(val) >= 0 && Number(val) <= 100)) setInvestorAllocation(val)
                    }}
                    onKeyDown={e => {
                      if (e.key === '-' || e.key === 'e') e.preventDefault()
                    }}
                    placeholder="0"
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: 11, color: '#888', display: 'block', marginBottom: 2 }}>
                    Amount (BHD)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    disabled
                    value={
                      chargeAmount && investorAllocation !== ''
                        ? Math.round((Number(investorAllocation) / 100) * Number(chargeAmount) * 100) / 100
                        : ''
                    }
                    placeholder="0.00"
                  />
                </div>
              </div>
            </div>

            {/* BenneFin Allocation */}
            <div className="col-md-6">
              <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>
                BenneFin Allocation
              </label>
              <div className="d-flex gap-2">
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: 11, color: '#888', display: 'block', marginBottom: 2 }}>
                    Percentage (%)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    disabled
                    value={
                      investorAllocation !== ''
                        ? Math.round((100 - Number(investorAllocation)) * 100) / 100
                        : ''
                    }
                    placeholder="0"
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ fontSize: 11, color: '#888', display: 'block', marginBottom: 2 }}>
                    Amount (BHD)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    disabled
                    value={
                      chargeAmount && investorAllocation !== ''
                        ? Math.round((100 - Number(investorAllocation)) / 100 * Number(chargeAmount) * 100) / 100
                        : ''
                    }
                    placeholder="0.00"
                  />
                </div>
              </div>
            </div>

            {/* Description */}
            <div className="col-12">
              <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>
                Description <span style={{ color: 'red' }}>*</span>{' '}
                <span style={{ fontSize: 11, color: '#888', fontWeight: 400 }}>(shown on dashboards)</span>
              </label>
              <textarea
                className="form-control"
                rows={2}
                value={chargeDescription}
                onChange={e => setChargeDescription(e.target.value)}
                placeholder="e.g. Extension fee for 2 month tenure extension"
              />
            </div>

            {/* Remarks */}
            <div className="col-12">
              <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>
                Remarks
              </label>
              <textarea
                className="form-control"
                rows={2}
                value={chargeRemarks}
                onChange={e => setChargeRemarks(e.target.value)}
                placeholder="Internal notes for context"
              />
            </div>
          </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn_background px-4"
          onClick={() => setShowChargeModal(false)}
          disabled={chargeLoading}
        >
          Cancel
        </button>
        <button
          className="btn blue_btn px-4"
          onClick={handleCreateCharge}
          disabled={chargeLoading || !chargeType || !chargeAmount || !chargeDate || !chargeDescription.trim()}
        >
          {chargeLoading ? 'Saving...' : 'Save Charge'}
        </button>
      </Modal.Footer>
    </Modal>

    <Modal
      show={showCloseLoanModal}
      onHide={() => setShowCloseLoanModal(false)}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16, fontWeight: 500 }}>Close this loan?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ fontSize: 13, color: '#555' }}>
          All outstanding amounts are settled. This marks the loan Closed and view-only —
          no further edits or status changes will be possible on this loan.
        </p>

        <div style={{
          background: '#FAEEDA', border: '1px solid #FAC775',
          borderRadius: 8, padding: '10px 14px', marginBottom: 16,
          fontSize: 12, color: '#854F0B'
        }}>
          <strong>Warning:</strong> Once confirmed, this action cannot be reversed from here.
          Corrections after closure go through a separate adjustment process.
        </div>

        <div className="form-check mb-2" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <input
            type="checkbox"
            id="closeLoanConfirm"
            checked={closeLoanConfirmed}
            onChange={e => setCloseLoanConfirmed(e.target.checked)}
            style={{ width: 16, height: 16, cursor: 'pointer', accentColor: '#185FA5' }}
          />
          <label htmlFor="closeLoanConfirm" style={{ fontSize: 13, cursor: 'pointer', marginBottom: 0 }}>
            I confirm all outstanding amounts have been verified as settled
          </label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn_background px-4"
          onClick={() => setShowCloseLoanModal(false)}
          disabled={closeLoanLoading}
        >
          Cancel
        </button>
        <button
          className="btn blue_btn px-4"
          onClick={handleCloseLoan}
          disabled={closeLoanLoading || !closeLoanConfirmed || !closureEligibility?.isSettled}
        >
          {closeLoanLoading ? 'Closing...' : 'Confirm Closure'}
        </button>
      </Modal.Footer>
    </Modal>
    </>
  );
};

export default NewInvDetailedView;
